import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { toggleSection, onClickAccHandler, sectionIsOpen, accScroll } from '../../shared/page-accordion';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        let state = {
            open_chapters: [],
            linkSelect: false,
            category: props.category,
            code: props.upc,
        };

        if (props.route) {
            state.open_chapters.push(props.route);
        }

        this.state = state;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.route != this.props.route) {
            if (nextProps.route != '') {
                if (nextProps.route === 'main') {
                    this.setState({ open_chapters: []});
                    accScroll('main', 500);
                } else {
                    if (!this.state.linkSelect) {
                        let opened = toggleSection(this.state.open_chapters, nextProps.route);
                        const state = this.state;
                        state.open_chapters = opened;
                        this.setState(state);
                    }

                    this.setState({ linkSelect: false });
                }
            }

            return true;
        }
        if (nextState != this.state) {
            return true;
        }
        if (nextProps.report != this.props.report) {
            return true;
        }

        return false;
    }

    render({ report }) {
        return (
            <numerology-report>
                {this.renderChapterLinks()}
                <section className='has-text-left-print interp-accordion'>
                    {report.product.display.sections.map((section, loop) => (this.renderChapters(section, loop)))}
                </section>
            </numerology-report>
        );
    }

    checkArray = (item) => {
        return Array.isArray(item);
    }

    /* eslint-disable max-len */
    renderChapterLinks = () => {
        const report = this.props.report;
        return (
            <p className='has-text-left-print has-text-center'>
                {report.product.navigator.map(chapter => (
                    <div>
                        <a
                            className='print-links'
                            href={`#${chapter.code}`}
                            onClick={(e) => { this.goTo(e, chapter.code, true); }}
                        >
                            Chapter {chapter.short_name}
                        </a>
                        <br />
                    </div>
                ))}
                {!!report.upsell_url && (
                    <a
                        href={report.upsell_url}
                    >
                        Get Your Full Report
                    </a>
                )}
            </p>
        );
    }

    renderChapters = (section, loop) => {
        const id = section.section_code;
        const isOpen = sectionIsOpen(this.state.open_chapters, id);
        const number = loop + 1;
        return (
            <div
                className={`interp-accordion-item ${isOpen ? ' accordion-open' : ' accordion-closed'}`}
                id={id}
            >
                <a
                    href={`#${id}`}
                    onClick={(e) => { this.goTo(e, id, false); }}
                    className='no-hover interp-accordion-item-tab'
                >
                    <row className='is-aligned-center has-padding-20-top has-padding-10-bottom has-padding-10-left'>
                        <column className='is-12'>
                            <div className='has-weight-400 has-text-size-18 has-text-color-black'>Chapter {number}</div>
                            <div className='has-margin-5-top has-margin-5-bottom has-text-size-14 has-text-boulder'>{section.title}</div>
                        </column>
                    </row>
                </a>
                <div className='interp-accordion-item-content'>
                    {
                        section.block.map(block => (
                            block.content.map((content) => (
                                <div>
                                    <h5 className='has-margin-10-left has-weight-400'>
                                        {!!content.date && (
                                            `${content.date}: `
                                        )}
                                        {content.title || ''}
                                    </h5>
                                    {
                                        !!content.body && this.checkArray(content.body)
                                            ?
                                            content.body.map(body => (
                                                <p className='has-margin-10-left has-margin-10-right'>{body}</p>
                                            ))
                                            :
                                            <p className='has-margin-10-left has-margin-10-right'>{content.body || ''}</p>
                                    }
                                </div>
                            ))

                        ))
                    }
                    <p className='is-hidden-print has-text-right has-margin-10-right'>
                        <a
                            href='#'
                            onClick={(e) => { this.goTo(e, 'main', true); }}
                            className='is-hidden-print'
                        >
                            Back to Top
                        </a>
                    </p>
                </div>
            </div>
        );
    }

    goTo = (e, chapter, shouldClose) => {
        e.preventDefault();
        let clickResult = onClickAccHandler(this.state.open_chapters, chapter, this.props.route);
        const state = this.state;
        if (shouldClose) {
            if (chapter === 'main') {
                state.open_chapters = [];
                clickResult[2] = false;
            } else {
                clickResult[2] = true;
                state.open_chapters = [chapter];
                state.linkSelect = true;
            }

            clickResult[1] = true;
        } else {
            state.open_chapters = clickResult[0];
        }

        this.setState(state);
        if (clickResult[1] == true) {
            this.props.routeTo(chapter);
        }
        if (clickResult[2] == true) {
            if (state.linkSelect) {
                accScroll(chapter, 500);
            } else {
                accScroll(chapter, 400);
            }
        }
    }
    /* eslint-enable max-len */
}

const mapStateToProps = (state) => ({
    route: state.route,
    report: state.report,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);